const question_data = {
  1: {
    nonQuestion: false,
    title: 'Essential Conditions',
    heading: 'Question 1 of 3',
    question: 'Are you a UK resident and have home student fee status?',
    description: `By ‘home student fee status’ we mean that you have the right to reside in the UK, or have been granted permission from the Home Office.<br /><br />If you are an asylum seeker or refugee, select ‘Yes’ and use this tool as an indicator of your eligibility for PARTNERS. Your eligibility and home fee status will be reviewed by the admissions team upon receipt of your UCAS application.`,
    type: 'radio',
    stage: 1,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: 2,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: null,
      }
    },
    previousQuestion: null,
  },
  2: {
    nonQuestion: false,
    title: 'Essential Conditions',
    heading: 'Question 2 of 3',
    question: 'What course are you applying for?',
    description: `To check the PARTNERS entry requirements:<br />
    1. Use the search bar below to find the course that you're interested in.<br />
    2. Click the link that appears below 'Click to view entry requirements'. This will open a new window.<br />
    3. In the new page, scroll down to the dropdown menu labelled 'Other UK and the Republic of Ireland qualifications (This includes PARTNERS)', and select the qualification that you're studying from the dropdown menu.<br />`,
    type: 'course',
    stage: 1,
    answers: {
      nextQuestion: 3,
      subQuestion: {
        heading: 'Predicted Grades',
        question: `Are your predicted grades within one A level grade (or equivalent) of the PARTNERS Entry Requirements for the course that you're interested in?`,
        description: `If you're unsure what your predicted grades are at the moment, select 'Yes' and use this tool as an indicator of your eligibility for PARTNERS. Your eligibility will be dependent upon the predicted grades submitted on your UCAS application form.`,
        type: 'radio',
        answers: {
          0: {
            text: 'Yes',
            eligible: true,
            nextQuestion: 3,
          },
          1: {
            text: 'No',
            eligible: false,
            nextQuestion: null,
          }
        },
      }
    },
    previousQuestion: 1,
  },
  3: {
    nonQuestion: false,
    title: 'Essential Conditions',
    heading: 'Question 3 of 3',
    question: 'Do you already have a higher education qualification (e.g. a degree or higher degree)?',
    description: '',
    type: 'radio',
    stage: 1,
    answers: {
      0: {
        text: 'Yes',
        eligible: false,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: true,
        nextQuestion: 4,
      }
    },
    previousQuestion: 2,
  },
  4: {
    nonQuestion: true,
    title: 'Eligibility Criteria',
    heading: '',
    question: 'You meet the essential conditions, however you must also meet at least one of the eligibility criteria.',
    description: 'In order to be eligible for our PARTNERS Programme you will need to meet one further requirement <strong>known as eligibility criteria</strong>. If you already know what criteria you meet, please choose from the dropdown and select continue.',
    aboveFooterText: 'Alternatively, you can work through these one at a time by selecting \'Continue to eligibility criteria\'.',
    aboveFooterTextSize: 'standard',
    type: 'question_jump',
    stage: 2,
    answers: {
      nextQuestion: 5,
    },
    previousQuestion: null,
    nextQuestion: 5,
  },
  5: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Postcode Checker',
    question: 'Postcode entered into the checker:',
    questionAlt: 'Your home postcode',
    description: 'Please enter your full postcode then click the search icon.',
    type: 'postcode',
    stage: 2,
    answers: {
      nextQuestion: 6,
    },
    previousQuestion: 4,
    nextQuestion: 6,
  },
  6: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Previous Education',
    question: 'Use the search bar below to check if your GCSE or A-Level school is on our eligibility list. You can search using either the school\'s name or the town/city it\'s located. If your school/college does not appear on the dropdown list, it means that you don\'t meet this criterion. Click \'Skip\' to check if you meet one of our other eligibility criteria.',
    questionAlt: 'The school or college you attend or have attended',
    type: 'school',
    stage: 2,
    answers: {
      nextQuestion: 7,
    },
    previousQuestion: 5,
    nextQuestion: 7,
  },
  7: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Financial support',
    question: 'Are you in receipt of, or entitled to financial support?',
    questionAlt: 'Your entitlement to financial support',
    stage: 2,
    description: 'For example, any of the following:',
    descriptionList: [
      'Free school meals',
      'Pupil Premium funding',
      'Discretionary school/college payments directly linked to financial hardship'
    ],
    aboveFooterText: 'If you are unsure if you are eligible on this criteria please contact the <a href="https://www.ncl.ac.uk/partners/help-and-support/contact-us/" target="_blank">PARTNERS team.</a>',
    type: 'radio',
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 8,
      }
    },
    previousQuestion: 6,
    nextQuestion: 8,
  },
  8: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Care Experienced Student',
    question: 'Have you experienced any time in care during your life?',
    questionAlt: 'You have experienced time in care',
    description: 'This could include any of the following:',
    descriptionList: [
      'You live or have lived in foster care.',
      'You live or have lived in a residential children’s home.',
      'You have been looked after at home under a supervision order.',
      'You live or have lived with friends or relatives in kinship care.',
    ],
    aboveFooterText: 'If you are unsure if you are eligible on this criteria please contact the <a href="https://www.ncl.ac.uk/partners/help-and-support/contact-us/" target="_blank">PARTNERS team.</a>',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 9,
      }
    },
    previousQuestion: 7,
    nextQuestion: 9,
  },
  9: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Parenting and care',
    question: 'Are you a parent/carer who is responsible for the care and wellbeing of a child under the age of 17?',
    questionAlt: 'You are a parent/carer and responsible for a child under the age of 17',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 10,
      }
    },
    previousQuestion: 8,
    nextQuestion: 10,
  },
  10: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Young Carers',
    question: 'Do you have sole or shared responsibility for the care of a relative because they are ill, have a disability, are experiencing mental distress or affected by substance abuse?',
    questionAlt: 'You are a recognised carer',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 11,
      }
    },
    previousQuestion: 9,
    nextQuestion: 11,
  },
  11: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Health and Disabilities',
    question: 'Do you have a disability or long-term health condition and are in receipt of the Personal Independence Payment (PIP)?',
    questionAlt: 'You have a disability/long-term health condition',
    list: [
      'The ‘enhanced’ rate in either the ‘daily living’ or ‘mobility’ components.',
    ],
    list2: [
      'The ‘standard’ rate in both components.',
    ],
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 12,
      }
    },
    previousQuestion: 10,
    nextQuestion: 12,
  },
  12: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Family Education',
    question: 'Do either of your parents/carers have any higher education qualifications?',
    questionAlt: 'Your parent/carers\' experience of higher education',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Higher Degree (eg MA, MSc, PhD, PGCE)',
        eligible: false,
        nextQuestion: 13,
      },
      1: {
        text: 'First Degree (eg BA, BSc)',
        eligible: false,
        nextQuestion: 13,
      },
      2: {
        text: 'No higher education qualifications',
        eligible: true,
        nextQuestion: null,
      },
    },
    previousQuestion: 11,
    nextQuestion: 13,
  },
  13: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Estranged Students',
    question: 'Are you an estranged person, who no longer has the support of your family due to a breakdown in relationships which has led to ceased contact?',
    questionAlt: 'You are an estranged young person',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 14,
      }
    },
    previousQuestion: 12,
    nextQuestion: 14,
  },
  14: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Armed Forces',
    question: 'Have you or either of your parents/carers served in the armed forces during key educational times?',
    questionAlt: 'Your family have served in the military',
    description: 'The British Armed Forces consists of:<br />' +
      '- Royal Navy, Royal Marines, British Army, Royal Air Force, Regular Reserves, Volunteer Reserves and Sponsored Reserves<br /><br />' +
      'We define key educational time as the study periods which affect the completion of your GCSE and/or A-level qualifications.',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 15,
      }
    },
    previousQuestion: 13,
    nextQuestion: 15,
  },
  15: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Black, Asian or Minoritised Ethnic Group attending a state school.',
    question: 'Are you from a Black, Asian or Minoritised Ethnic Group and attend/attended a state school or college in the United Kingdom, when sitting your A-Levels (or equivalent)?',
    questionAlt: 'You are from a Black, Asian or Minoritised Ethnic Group and attend a state school',
    description: 'Students from the following ethnic groups are eligible via this criterion:',
    descriptionList: [
      'Arab',
      'Asian or Asian British – Indian',
      'Asian or Asian British – Pakistani',
      'Asian or Asian British – Bangladeshi',
      'Black or Black British – Caribbean',
      'Black or Black British – African',
      'Chinese',
      'Mixed White and Black Caribbean',
      'Mixed White and Black African',
      'Mixed White and Asian',
      'Other Black background',
      'Other Asian background',
      'Other Mixed background',
    ],
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 16,
      }
    },
    previousQuestion: 14,
    nextQuestion: 16,
  },
  16: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Ethnic status',
    question: 'Are you from a Gypsy, Roma or Traveller community?',
    questionAlt: 'You are from a Gypsy, Roma or Traveller community',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 17,
      }
    },
    previousQuestion: 15,
    nextQuestion: 17,
  },
  17: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Refugees',
    question: 'Do you have refugee status? You must have been given ‘leave to remain’ or ‘leave to enter’ by the UK Government and be able to prove this.',
    questionAlt: 'You have refugee status',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 18,
      }
    },
    previousQuestion: 16,
    nextQuestion: 18,
  },
  18: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Asylum Seeker',
    question: 'Are you seeking asylum in the United Kingdom?',
    questionAlt: 'You are an asylum seeker',
    description: 'Applicants must meet the English language criteria for their course or have relevant qualifications to indicate their English language competency. To check requirements for individual courses please refer to our <a href="https://www.ncl.ac.uk/undergraduate/degrees/" target="_blank">subject web pages</a>. Your status will be verified by our admissions team on submission of your UCAS application.',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: 19,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 19,
      }
    },
    previousQuestion: 17,
    nextQuestion: 19,
  },
  19: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'Humanitarian Protection',
    question: 'Are you currently under Humanitarian Protection, granted by the UK government? Your status will be verified by our admissions team on the submission of your UCAS application.',
    questionAlt: 'You are under humanitarian protection',
    type: 'radio',
    stage: 2,
    answers: {
      0: {
        text: 'Yes',
        eligible: true,
        nextQuestion: null,
      },
      1: {
        text: 'No',
        eligible: false,
        nextQuestion: 20,
      }
    },
    previousQuestion: 18,
    nextQuestion: 20,
  },
  20: {
    nonQuestion: false,
    title: 'Eligibility Criteria',
    heading: 'The course you are applying to at Newcastle University',
    question: 'Have you applied to or are you planning on applying to any of the following courses?',
    description: '<strong>Please note: If you are applying for multiple courses at Newcastle University but only meet this specific criteria, you can only be made the lower PARTNERS offer for the participating courses listed below. If you do not meet any of the other PARTNERS <a target="_blank" rel="noopener noreferrer" href="https://www.ncl.ac.uk/partners/how-to-apply/eligibility/">widening participation criteria</a>, any application to any other course(s) will be processed in the standard way. <a target="_blank" rel="noopener noreferrer" href="https://www.ncl.ac.uk/partners/how-to-apply/eligibility/engineering-maths-physics/">Visit this webpage</a> to find out more.</strong>',
    questionAlt: 'The course you are applying to at Newcastle University',
    type: 'select',
    stage: 2,
    answers: {
      0: {
        text: 'Mathematics and Accounting (BSc) - (Programme Code: NG41)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      1: {
        text: 'Mathematics and Economics (Bsc)	- (Programme Code: GL11)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      2: {
        text: 'Mathematics (BSc) - (Programme Code: G100)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      3: {
        text: 'Mathematics (MMath)	- (Programme Code: G103)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      4: {
        text: 'Mathematics and Statistics (BSc) - (Programme Code: GG13)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      5: {
        text: 'Mathematics and Statistics (MMathStat) - (Programme Code: GGC3)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      6: {
        text: 'Mathematics with Business (BSc) - (Programme Code: G1N4)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      7: {
        text: 'Mathematics with Finance (BSc) - (Programme Code: G1N3)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      8: {
        text: 'Physics (BSc) - (Programme Code: F300)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      9: {
        text: 'Physics (MPhys) - (Programme Code: F303)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      10: {
        text: 'Theoretical Physics (BSc) - (Programme Code: F345)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      11: {
        text: 'Theoretical Physics (MPhys) - (Programme Code: F344)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      12: {
        text: 'Physics with Astrophysics (BSc) - (Programme Code: F3F5)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      13: {
        text: 'Physics with Astrophysics (MPhys) - (Programme Code: F3FM)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      14: {
        text: 'Mechanical Engineering (BEng) - (Programme Code: H300)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      15: {
        text: 'Mechanical Engineering (MEng) - (Programme Code: H301)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      16: {
        text: 'Chemical Engineering (BEng) - (Programme Code: H810)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      17: {
        text: 'Chemical Engineering (MEng) - (Programme Code: H813)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      18: {
        text: 'Chemical Engineering with Industry (MEng) - (Programme Code: H815)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      19: {
        text: 'Marine Engineering (BEng) - (Programme Code: H506)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      20: {
        text: 'Marine Engineering (MEng) - (Programme Code: H507)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      21: {
        text: 'Naval Architecture (BEng) - (Programme Code: H508)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      22: {
        text: 'Naval Architecture (MEng) - (Programme Code: H509)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      23: {
        text: 'Electrical and Electronic Engineering BEng - (Programme Code: H607)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      24: {
        text: 'Electrical and Electronic Engineering with Industrial Project (MEng) - (Programme Code: H605)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      25: {
        text: 'Electronics and Computer Engineering (BEng) - (Programme Code: H652)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      26: {
        text: 'Electronics and Computer Engineering with Industrial Project (MEng) - (Programme Code: H654)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      27: {
        text: 'Civil Engineering (BEng) - (Programme Code: H200)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      28: {
        text: 'Civil Engineering (MEng) - (Programme Code: H290)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      29: {
        text: 'Civil Engineering with Year in Industry (BEng) - (Programme Code: H205)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      30: {
        text: 'Civil Engineering with Year in Industry (MEng) - (Programme Code: H295)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      31: {
        text: 'Civil and Structural Engineering (BEng) - (Programme Code: H210)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      32: {
        text: 'Civil and Structural Engineering (MEng) - (Programme Code: H242)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      33: {
        text: 'Civil and Structural Engineering with Year in Industry (BEng) - (Programme Code: H206)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      34: {
        text: 'Civil and Structural Engineering with Year in Industry(MEng) - (Programme Code: H296)',
        eligible: true,
        nextQuestion: null,
        courseApplication: true,
      },
      35: {
        text: 'Biology (BSc) - (Programme Code: C100)',
        eligible: true,
        nextQuestion: null,
      },
      36: {
        text: 'Biology (Mbiol) - (Programme Code: C103)',
        eligible: true,
        nextQuestion: null,
      },
      37: {
        text: 'Marine Biology (BSc) - (Programme Code: C161)',
        eligible: true,
        nextQuestion: null,
      },
      38: {
        text: 'Zoology (BSc) - (Programme Code: C300)',
        eligible: true,
        nextQuestion: null,
      },
      39: {
        text: 'Zoology (Mbiol) - (Programme Code: C301)',
        eligible: true,
        nextQuestion: null,
      },
      40: {
        text: 'Animal Science (BSc) - (Programme Code: C305)',
        eligible: true,
        nextQuestion: null,
      },
      41: {
        text: 'Marine Zoology (BSc) - (Programme Code: C350)',
        eligible: true,
        nextQuestion: null,
      },
      42: {
        text: 'Agriculture (BSc) - (Programme Code: D400)',
        eligible: true,
        nextQuestion: null,
      },
      43: {
        text: 'Agriculture with Farm Business Management (BSc) - (Programme Code: D402)',
        eligible: true,
        nextQuestion: null,
      },
      44: {
        text: 'Countryside Management (BSc) - (Programme Code: D455)',
        eligible: true,
        nextQuestion: null,
      },
      45: {
        text: 'Chemistry (BSc) - (Programme Code: F100)',
        eligible: true,
        nextQuestion: null,
      },
      46: {
        text: 'Chemistry with Industrial Training (BSc) - (Programme Code: F102)',
        eligible: true,
        nextQuestion: null,
      },
      47: {
        text: 'Chemistry (MChem) - (Programme Code: F103)',
        eligible: true,
        nextQuestion: null,
      },
      48: {
        text: 'Chemistry (with Industrial Training) (MChem) - (Programme Code: F106)',
        eligible: true,
        nextQuestion: null,
      },
      49: {
        text: 'Chemistry with Study Abroad (MChem) - (Programme Code: F107)',
        eligible: true,
        nextQuestion: null,
      },
      50: {
        text: 'Chemistry with Study Abroad (BSc) - (Programme Code: F109)',
        eligible: true,
        nextQuestion: null,
      },
      51: {
        text: 'Chemistry with Medicinal Chemistry with  Industrial Training (BSc) - (Programme Code: F122)',
        eligible: true,
        nextQuestion: null,
      },
      52: {
        text: 'Chemistry with Medicinal Chemistry (MChem) - (Programme Code: F123)',
        eligible: true,
        nextQuestion: null,
      },
      53: {
        text: 'Chemistry with Medicinal Chemistry with Industrial Training (Mchem) - (Programme Code: F124)',
        eligible: true,
        nextQuestion: null,
      },
      54: {
        text: 'Chemistry with Medicinal Chemistry (BSc) - (Programme Code: F151)',
        eligible: true,
        nextQuestion: null,
      },
      55: {
        text: 'Chemistry with Medicinal Chemistry with Study Abroad (BSc) - (Programme Code: F155)',
        eligible: true,
        nextQuestion: null,
      },
      56: {
        text: 'Chemistry with Medicinal Chemistry with Study Abroad (MChem) - (Programme Code: F156)',
        eligible: true,
        nextQuestion: null,
      },
      57: {
        text: 'Earth Science (BSc) - (Programme Code: F641)',
        eligible: true,
        nextQuestion: null,
      },
      58: {
        text: 'Environmental Science(BSc) - (Programme Code: F850)',
        eligible: true,
        nextQuestion: null,
      },
      59: {
        text: 'Agri-Business Management (BSc) - (Programme Code: N280)',
        eligible: true,
        nextQuestion: null,
      },
      60: {
        text: 'Food Business Management and Marketing (BSc) - (Programme Code: ND61)',
        eligible: true,
        nextQuestion: null,
      },
      61: {
        text: 'No',
        eligible: false,
        nextQuestion: null,
      }
    },
    previousQuestion: 19,
    nextQuestion: null,
  },
};

export default question_data;